var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSideLogoBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 460,
    height: 1024,
    viewBox: "0 0 460 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35687_27391)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -17,
    y: -15,
    width: 460,
    height: 1024,
    rx: 16,
    fill: "url(#paint0_linear_35687_27391)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_35687_27391",
    x1: -2.00001,
    y1: 0.00000431762,
    x2: 367.5,
    y2: 1039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#022C66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#0045A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006aff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35687_27391"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 460,
    height: 1024,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideLogoBackground);
export default __webpack_public_path__ + "static/media/sideLogoBackground.2d2b8df7bfb336d6bd103c24e2402d8a.svg";
export { ForwardRef as ReactComponent };